import { render } from "./MenuItemFolder.vue?vue&type=template&id=1d9f2e50"
import script from "./MenuItemFolder.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuItemFolder.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/MenuItemFolder.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1d9f2e50"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1d9f2e50', __exports__)) {
    api.reload('1d9f2e50', __exports__)
  }
  
  module.hot.accept("./MenuItemFolder.vue?vue&type=template&id=1d9f2e50", () => {
    api.rerender('1d9f2e50', render)
  })

}


export default __exports__